import { RESET_REDUCER } from '../../../actions/resetReducers';
import { API_LOGIN_ENDPOINTS } from '../../../actions/ApiAuth/ApiAuthEndpoints';

const initialState = { linkSent: false, sentTo: '' };

export const resetPassword = (state = initialState, action) => {
    switch (action.type) {
        case RESET_REDUCER:
            return initialState;
        case API_LOGIN_ENDPOINTS.API.API_AUTH_PASSWORD_FORGOT:
            return { linkSent: true, sentTo: action.data.sentTo };
        default:
            return state;
    }
};
